import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllBookingLines(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + `/api/reports/bookingLines/all`, { ...data })
          .then(({ data }) => {
            data.success ? resolve(data.data) : reject(data.error);
          })
          .catch(reject);
      });
    },
    getBookingLinesForUsers(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + `/api/reports/bookingLines/users`, {
            ...data
          })
          .then(({ data }) => {
            data.success ? resolve(data.data) : reject(data.error);
          })
          .catch(reject);
      });
    },
    getAllVacationReports(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + `/api/reports/absences/all`, {
            ...data
          })
          .then(({ data }) => {
            data.success ? resolve(data.data) : reject(data.error);
          })
          .catch(reject);
      });
    },
    getVacationReportsForUsers(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + `/api/reports/absences/users`, {
            ...data
          })
          .then(({ data }) => {
            data.success ? resolve(data.data) : reject(data.error);
          })
          .catch(reject);
      });
    },
    process(_, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + `/api/reports/bookingLines/process`, {
            ...data
          })
          .then(({ data }) => {
            data.success ? resolve(data.data) : reject(data.error);
          })
          .catch(reject);
      });
    }
  },
  modules: {}
};
